export class ThemeUtils {
    static readonly BACKGROUND_COLOR = '#FDFDFD';

    static actionGradient(): string {
        return 'linear-gradient(to left, #DABEE2, #42abab)';
    }

    static gradientBackground(): string {
        return 'linear(to top right, #c2eded95, #DABEE295)';
    }
}
